import React, { Component } from 'react'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'
import {
  fetchDashboardStatements,
  resetDashboardStatements,
  sendStatementemail
} from 'alelo-logic/actions'
import StatementsHeader from '../../elements/StatementsHeader'
import AddItem from '../../modules/AddItem'
import StatementsList from '../../modules/StatementsList'
import { setLoading } from '../../modules/PageLoader/actions'
import PartnerStatementsFilter from './PartnerStatementsFilter/PartnerStatementsFilter'

import EmailStatementModal from '../../modules/EmailStatementModal'

import Content from '../../../styles/objects/Content'
import { Title, Paragraph } from './styles'
import { helmetTitle, topbar } from './data.json'

import statementFactory from './factory'

import { showModal } from '../../modules/ModalRoot/actions'
import imageContestacao from '../../../static/contestacao.png'
import { CONFIRM_UPDATE } from '../../../constants/ModalTypes'

class DashboardStatement extends Component {
  state = {
    showFilter: false,
    showResults: false,
    loading: false,
    showModalEmail: false,
    formato: null,
    emailSendStatement: null
  }

  componentDidMount() {
    this.props.setLoading(false)
  }

  componentWillUnmount() {
    this.props.resetStatements()
  }

  selectedFilters = {}

  resetList() {
    this.props.resetStatements()
    this.doStatementFetch()
  }

  loadStatements = (nextPage = 0) => {
    const params = this.props.match.params || {}
    this.props.fetchStatements(params.id, nextPage, this.selectedFilters)
  }

  doStatementFetch = (nextPage, filter) => {
    const params = this.props.match.params || {}
    this.props.fetchStatements(params.id, nextPage, filter).then(() => {
      this.setState({ loading: false })
    })
    this.setState({ loading: true })
  }

  openFilter = () => {
    this.setState({ showFilter: true })
  }

  unsetResults = () => this.setState({ showResults: false })

  applyFilter = filter => {
    this.selectedFilters = filter
    this.props.resetStatements()
    this.doStatementFetch(null, this.selectedFilters)
    this.setState({ showFilter: false, showResults: true })
  }

  closeFilter = () => {
    this.setState({ showFilter: false })
  }

  handleModal = async () => {
    const { emailSendStatement, formato } = this.state
    const params = this.props.match.params || {}

    await this.props.sendStatementEmail(
      params.id,
      emailSendStatement,
      this.selectedFilters,
      formato
    )

    this.setState({ showModalEmail: !this.state.showModalEmail, formato: null })
  }

  handleChangeEmail = value => {
    const result = Object.keys(value).map(function(key) {
      return [value[key]]
    })

    const valueEmail = result.splice(0, result.length - 1).join('')
    this.setState({ emailSendStatement: valueEmail })
  }

  modalEmail = (state, formato) => this.setState({ showModalEmail: state, formato })

  render() {
    const { statements, accountPlans } = this.props
    const { showModalEmail, showFilter, showResults } = this.state
    return (
      <div>
        <Helmet title={helmetTitle} />
        <PartnerStatementsFilter
          onFilter={values => this.applyFilter(values)}
          statements={statements}
          accountPlans={accountPlans}
          showFilter={showFilter}
          showResults={showResults}
          unsetResults={this.unsetResults}
        />
        {showResults && (
          <div>
            <StatementsHeader
              statements={statements}
              currency={topbar.currency}
              match={this.props.match}
              downloadEnabled={!!statements.data.length}
              openModal={this.modalEmail}
            />
            {statements.data.length === 0 ? (
              <Content>
                <Title>Ops!</Title>
                <Paragraph>Nenhuma transação encontrada para o filtro selecionado.</Paragraph>
              </Content>
            ) : (
              <div>
                <AddItem
                  data={statementFactory.toForm(statements.data)}
                  next={statements.next}
                  fetchHandler={this.loadStatements}
                  hasNext={statements.hasNext}
                >
                  <StatementsList />
                </AddItem>
              </div>
            )}
          </div>
        )}

        {showModalEmail && (
          <EmailStatementModal
            handleClick={this.handleModal}
            openModal={this.modalEmail}
            handleChangeEmail={this.handleChangeEmail}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = ({ reducer }) => ({
  statements: reducer.dashboardStatements,
  accountPlans: reducer.accountPlans
})

const mapDispatchToProps = dispatch => ({
  fetchStatements: (planId, nextPage, filter) =>
    dispatch(fetchDashboardStatements(planId, nextPage, filter)).then(resp => {
      if (resp && resp.status === 204) {
        dispatch(setLoading(false))
        dispatch(resetDashboardStatements())
      }
      dispatch(setLoading(false))
    }),
  sendStatementEmail: (planId, email, filter, formato) =>
    dispatch(sendStatementemail(planId, email, filter, formato)).then(() => {
      dispatch(
        showModal(CONFIRM_UPDATE, {
          modalTitle: 'Extrato em processamento.',
          modalDescription: `O ${formato} do seu extrato está em processamento, assim que finalizado você recebera um email com o link para baixa-lo.`,
          image: imageContestacao
        })
      )
      dispatch(setLoading(false))
    }),
  resetStatements: () => {
    dispatch(setLoading(true))
    dispatch(resetDashboardStatements())
  },
  setLoading: isLoading => {
    dispatch(setLoading(isLoading))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(DashboardStatement)



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatementPartner/index.js